"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  variant: {
    title: {
      en: 'Variant',
      ru: 'Вариант'
    },
    control: 'radio-group',
    variants: [{
      title: {
        en: 'Vertical',
        ru: 'Вертикальный'
      },
      value: 'vertical'
    }, {
      title: {
        en: 'Horizontal',
        ru: 'Горизонтальный'
      },
      value: 'horizontal'
    }]
  },
  show: {
    title: {
      en: 'Show',
      ru: 'Показать'
    },
    category: 'Test',
    control: 'checkbox'
  }
};
exports["default"] = _default;